import { Chip } from '@global-engineering-shared/gweb-material-global';
import React from 'react';

import useStyles from 'features/Import/components/ImportDialog/components/ImportChipTextInput/components/ImportChipList.styles';

type ImportChipListProps = {
  chips: string[];
  visibleChipsCount: number;
  maxVisibleChips: number;
  handleOnDelete: (index: number) => void;
  showMoreChips: () => void;
};

const ImportChipList = ({
  chips,
  visibleChipsCount,
  maxVisibleChips,
  handleOnDelete,
  showMoreChips,
}: ImportChipListProps) => {
  const classes = useStyles();
  const isPaginated = chips.length > maxVisibleChips;

  return (
    <>
      {chips.slice(0, isPaginated ? visibleChipsCount : chips.length).map((chip, index) => (
        <Chip
          className={classes.root}
          key={index}
          label={chip}
          onDelete={() => handleOnDelete(index)}
        />
      ))}
      {isPaginated && visibleChipsCount < chips.length && (
        <Chip
          className={classes.root}
          clickable
          label={`Show more (${visibleChipsCount} of ${chips.length})`}
          onClick={showMoreChips}
        />
      )}
    </>
  );
};

export default ImportChipList;
